import {
  Box,
  Button,
  Divider,
  Drawer,
  Grid,
  IconButton,
  Menu,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import TextView from "../../Components/UI/TextView/TextView";
import { useTour } from "@reactour/tour";
import EditCalendarOutlinedIcon from "@mui/icons-material/EditCalendarOutlined";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useDispatch, useSelector } from "react-redux";
import UseAppointmentsStats from "../../helper/UseAppointmentsStats";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { logout } from "../../redux/slices/authSlice";
import { useNavigate } from "react-router-dom";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CustomModal from "../../Components/CustomModal/CustomModal";
import FutureAppointmentStatus from "../../Components/ModalChildren/FutureAppointmentStatus";
import { Menu as MenuIcon } from "@mui/icons-material";
import logo from "../../assets/logo_sq.svg";
import { toggleMobileSidebar } from "../../redux/slices/uiSlice";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DoctorDashboard from "../../Components/ModalChildren/DoctorDashboard";
import useOrgName from "../../helper/useOrgName";

const PrescriptionNavbar = () => {
  const isMdUp = useMediaQuery("(min-width:600px)");
  const isCompact = useMediaQuery("(max-width: 1450px)");

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = useState(false);
  const [dashBoardOpen, setDashBoardOpen] = useState(false);
  const handleAppointmentStatusOpen = () => setOpen(true);
  const handleAppointmentStatusClose = () => setOpen(false);

  const { setIsOpen, setCurrentStep } = useTour();

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const authState = useSelector((state) => state.auth);
  const orgName = useOrgName();
  const { data: appointmentStats } = UseAppointmentsStats();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
    // window.location.reload();
  };

  return (
    <>
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          p: 0,
          m: 0,
          gap: 1,
        }}
      >
        <Box sx={{ display: "flex", gap: 1 }}>
          {/* /* MOBILE BURGER */}
          {!isMdUp && (
            <IconButton onClick={() => dispatch(toggleMobileSidebar())}>
              <MenuIcon
                sx={{ color: "black", height: "1.5rem", width: "1.5rem" }}
              />
            </IconButton>
          )}

          {/* LEFT - LOGO */}
          <Box display="flex" alignItems="center">
            <img src={logo} alt="logo" style={{ width: "3.5rem" }} />
          </Box>
        </Box>

        {/* DESKTOP VIEW */}
        {isMdUp && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              color: "black",
              justifyContent: "space-between",
              width: "100%",
              marginLeft: "4rem",
            }}
          >
            <Box
              sx={{ display: "flex", alignItems: "center", gap: "5px" }}
            ></Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "50%",
                justifyContent: "flex-end",
                gap: 0.2,
              }}
            >
              {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  backgroundColor: "neutral.blueShadeBg",
                  // border: '2px solid #E1E1E1',
                  borderRadius: "16PX",
                  paddingX: "10px",
                  paddingY: "10PX",
                  //   marginLeft: "8px",
                }}
                onClick={() => setDashBoardOpen(true)}
              >
                <Box
                  sx={{
                    backgroundColor: "#0097B240",
                    width: "35px",
                    height: "35px",
                    borderRadius: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <DashboardIcon width={24} sx={{ color: "#0097B2" }} />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    cursor: "pointer",
                    marginLeft: "4px",
                    // backgroundColor: "#FFFFFF",
                  }}
                >
                  <TextView
                    fontWeight={600}
                    fontSize={"14px"}
                    sx={{ mx: 2, color: "neutral.black", marginBottom: "3px" }}
                  >
                    Teleconsultation
                  </TextView>
                </Box>
              </Box> */}

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  backgroundColor: "neutral.blueShadeBg",
                  // border: '2px solid #E1E1E1',
                  borderRadius: "16PX",
                  paddingX: "10px",
                  paddingY: "10PX",
                  marginLeft: "8px",
                }}
                onClick={handleAppointmentStatusOpen}
              >
                <Box
                  sx={{
                    backgroundColor: "#0097B240",
                    width: "35px",
                    height: "35px",
                    borderRadius: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <EditCalendarOutlinedIcon
                    width={24}
                    sx={{ color: "#0097B2" }}
                  />
                  {/* <img src={dateTotal} alt="" width={"26px"} /> */}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    cursor: "pointer",
                    marginLeft: "4px",
                    // backgroundColor: "#FFFFFF",
                  }}
                >
                  <TextView
                    fontWeight={600}
                    fontSize={"14px"}
                    sx={{ mx: 2, color: "neutral.black", marginBottom: "3px" }}
                  >
                    Future Appointments
                  </TextView>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  backgroundColor: "neutral.blueShadeBg",
                  // border: '2px solid #E1E1E1',
                  borderRadius: "16PX",
                  paddingX: "10px",
                  paddingY: "10PX",
                  marginLeft: "6px",
                }}
                className="start-tour"
                onClick={() => {
                  setCurrentStep(0);
                  setTimeout(() => {
                    setIsOpen(true);
                    document.getElementById("fullName").focus();
                  }, 100);
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#0067FF40",
                    width: "35px",
                    height: "35px",
                    borderRadius: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <AutoStoriesOutlinedIcon
                    width={24}
                    sx={{ color: "#0097B2" }}
                  />
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    cursor: "pointer",
                    marginLeft: "-4px",
                  }}
                >
                  <TextView
                    fontWeight={600}
                    fontSize={"14px"}
                    sx={{ mx: 2, color: "neutral.black", marginBottom: "3px" }}
                  >
                    Tour Guide
                  </TextView>
                </Box>
              </Box>

              <IconButton onClick={handleMenuOpen} color="inherit">
                <AccountCircleIcon sx={{ height: "3rem", width: "3.5rem" }} />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                sx={{
                  marginLeft: "2.5rem",
                  marginTop: "-0.5rem",
                  "& .MuiPaper-root": {
                    borderRadius: "20px",
                    paddingTop: "-16px",
                    minWidth: "260px",
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "3px",
                    width: "320px",
                    padding: "10px",
                    borderRadius: "20px",
                  }}
                >
                  {orgName && (
                    <Box
                      sx={{
                        fontFamily: "Lato",
                        fontWeight: 700,
                        fontSize: "0.95rem",
                        marginLeft: "6px",
                        marginBottom: "2px",
                        color: "neutral.navyBlue",
                      }}
                    >
                      {orgName}
                    </Box>
                  )}
                  {authState?.first_name && (
                    <Box
                      sx={{
                        fontFamily: "Lato",
                        marginLeft: "6px",
                        marginBottom: "2px",
                      }}
                    >
                      {" "}
                      {authState?.first_name} {authState?.last_name}{" "}
                    </Box>
                  )}
                  {authState?.email && (
                    <Box
                      sx={{
                        marginBottom: "4px",
                        fontFamily: "Lato",
                        fontSize: "0.87rem",
                        marginLeft: "6px",
                      }}
                    >
                      {authState?.email}
                    </Box>
                  )}

                  <Box ml={"4px"} mt={"4px"}>
                    <Grid
                      container
                      sx={{
                        gap: "6px", // ⭐ spacing here
                      }}
                    >
                      <Grid
                        item
                        xs={5.8}
                        sx={{
                          backgroundColor: "neutral.blueShadeBg",
                          paddingY: "8px",
                          borderRadius: "14px",
                        }}
                      >
                        <Typography
                          variant="small_Text"
                          sx={{ paddingLeft: "12px", color: "neutral.black" }}
                        >
                          Total
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            paddingRight: "10px",
                          }}
                        >
                          <Box>
                            <Typography
                              variant="heading2_14"
                              sx={{ paddingLeft: "12px" }}
                            >
                              {appointmentStats?.appointments_total || 0}
                            </Typography>
                          </Box>
                          {/* <Box sx={{backgroundColor :'#E5FBF9' , marginRight:"8px",  paddingX:'5px', borderRadius:"20px", color:"#16D7CB" , fontSize:"12px",  fontFamily:"Outfit"}} display={'flex'} alignItems={'center'} >
                                 <ArrowDropUpIcon sx={{color:"#16D7CB"  , padding:'0px'}}/>
       
                                  {(appointmentStats?.appointments_total * 100) /appointmentStats?.appointments_total || 0}%
       
                                 </Box> */}
                        </Box>
                      </Grid>

                      <Grid
                        item
                        xs={5.8}
                        sx={{
                          backgroundColor: "neutral.blueShadeBg",
                          paddingY: "8px",
                          borderRadius: "14px",
                        }}
                      >
                        <Typography
                          variant="small_Text"
                          sx={{ paddingLeft: "12px", color: "neutral.black" }}
                        >
                          Complimentary
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            paddingRight: "10px",
                          }}
                        >
                          <Box>
                            <Typography
                              variant="heading2_14"
                              sx={{ paddingLeft: "12px" }}
                            >
                              {appointmentStats?.appointments_complimentary ||
                                0}{" "}
                              /{" "}
                              {appointmentStats?.appointments_complimentary_total ||
                                0}
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              backgroundColor: "#E5FBF9",
                              marginRight: "8px",
                              paddingX: "5px",
                              borderRadius: "20px",
                              color: "#16D7CB",
                              fontSize: "12px",
                              fontFamily: "Outfit",
                            }}
                            display={"flex"}
                            alignItems={"center"}
                          >
                            <ArrowDropUpIcon
                              sx={{ color: "#16D7CB", padding: "0px" }}
                            />
                            {(
                              (appointmentStats?.appointments_complimentary_total *
                                100) /
                                appointmentStats?.appointments_total || 0
                            ).toFixed(2)}
                            %
                          </Box>
                        </Box>
                      </Grid>

                      <Grid
                        item
                        xs={5.8}
                        sx={{
                          backgroundColor: "neutral.blueShadeBg",
                          paddingY: "8px",
                          borderRadius: "14px",
                        }}
                      >
                        <Typography
                          variant="small_Text"
                          sx={{ paddingLeft: "12px", color: "neutral.black" }}
                        >
                          New
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            paddingRight: "10px",
                          }}
                        >
                          <Box>
                            <Typography
                              variant="heading2_14"
                              sx={{ paddingLeft: "12px" }}
                            >
                              {appointmentStats?.appointments_new || 0} /{" "}
                              {appointmentStats?.appointments_new_total || 0}
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              backgroundColor: "#E5FBF9",
                              marginRight: "8px",
                              paddingX: "5px",
                              borderRadius: "20px",
                              color: "#16D7CB",
                              fontSize: "12px",
                              fontFamily: "Outfit",
                            }}
                            display={"flex"}
                            alignItems={"center"}
                          >
                            <ArrowDropUpIcon
                              sx={{ color: "#16D7CB", padding: "0px" }}
                            />
                            {(
                              (appointmentStats?.appointments_new_total * 100) /
                                appointmentStats?.appointments_total || 0
                            ).toFixed(2)}
                            %
                          </Box>
                        </Box>
                      </Grid>

                      <Grid
                        xs={5.8}
                        item
                        sx={{
                          backgroundColor: "neutral.blueShadeBg",
                          paddingY: "8px",
                          borderRadius: "14px",
                        }}
                      >
                        <Typography
                          variant="small_Text"
                          sx={{ paddingLeft: "8px", color: "neutral.black" }}
                        >
                          Review
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            paddingRight: "10px",
                          }}
                        >
                          <Box>
                            <Typography
                              variant="heading2_14"
                              sx={{ paddingLeft: "8px" }}
                            >
                              {appointmentStats?.appointments_review || 0} /{" "}
                              {appointmentStats?.appointments_review_total ||
                                0}{" "}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              backgroundColor: "#E5FBF9",
                              marginRight: "8px",
                              paddingX: "5px",
                              borderRadius: "20px",
                              color: "#16D7CB",
                              fontSize: "12px",
                              fontFamily: "Outfit",
                            }}
                            display={"flex"}
                            alignItems={"center"}
                          >
                            <ArrowDropUpIcon
                              sx={{ color: "#16D7CB", padding: "0px" }}
                            />
                            {(
                              (appointmentStats?.appointments_review_total *
                                100) /
                                appointmentStats?.appointments_total || 0
                            ).toFixed(2)}
                            %
                          </Box>
                        </Box>
                      </Grid>

                      <Grid
                        item
                        xs={5.8}
                        sx={{
                          backgroundColor: "neutral.blueShadeBg",
                          paddingY: "8px",
                          borderRadius: "14px",
                        }}
                      >
                        <Typography
                          variant="small_Text"
                          sx={{ paddingLeft: "8px", color: "neutral.black" }}
                        >
                          Old
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            paddingRight: "10px",
                          }}
                        >
                          <Box>
                            <Typography
                              variant="heading2_14"
                              sx={{ paddingLeft: "8px" }}
                            >
                              {appointmentStats?.appointments_old || 0} /{" "}
                              {appointmentStats?.appointments_old_total || 0}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              backgroundColor: "#E5FBF9",
                              marginRight: "8px",
                              paddingX: "5px",
                              borderRadius: "20px",
                              color: "#16D7CB",
                              fontSize: "12px",
                              fontFamily: "Outfit",
                            }}
                            display={"flex"}
                            alignItems={"center"}
                          >
                            <ArrowDropUpIcon
                              sx={{ color: "#16D7CB", padding: "0px" }}
                            />
                            {(
                              (appointmentStats?.appointments_old_total * 100) /
                                appointmentStats?.appointments_total || 0
                            ).toFixed(2)}
                            %
                          </Box>
                        </Box>
                      </Grid>

                      <Grid
                        item
                        xs={5.8}
                        sx={{
                          backgroundColor: "neutral.blueShadeBg",
                          paddingY: "8px",
                          borderRadius: "14px",
                        }}
                      >
                        <Typography
                          variant="small_Text"
                          sx={{ paddingLeft: "8px", color: "neutral.black" }}
                        >
                          Cancelled
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            paddingRight: "10px",
                          }}
                        >
                          <Box>
                            <Typography
                              variant="heading2_14"
                              sx={{ paddingLeft: "8px" }}
                            >
                              {appointmentStats?.appointments_cancelled ||
                                0}{" "}
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              backgroundColor: "#FFE5F6",
                              marginRight: "8px",
                              paddingX: "5px",
                              borderRadius: "20px",
                              color: "#FF392B",
                              fontSize: "12px",
                              fontFamily: "Outfit",
                            }}
                            display={"flex"}
                            alignItems={"center"}
                          >
                            <ArrowDropUpIcon
                              sx={{
                                color: "#FF392B",
                                padding: "0px",
                                transform: "rotate(180deg)",
                              }}
                            />
                            {(
                              (appointmentStats?.appointments_cancelled * 100) /
                                appointmentStats?.appointments_total || 0
                            ).toFixed(2)}
                            %
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>

                  <Button
                    //  style={{border :'2px solid black'}}
                    disableRipple
                    startIcon={
                      <LogoutOutlinedIcon
                        sx={{
                          borderRadius: "50%",
                          padding: "8px",
                          color: "neutral.navyBlue",
                          "&:hover": {
                            // backgroundColor: "neutral.navyBlue",
                            color: "white",
                          },
                        }}
                      />
                    }
                    sx={{
                      backgroundColor: "neutral.blueShadeBg",
                      marginTop: "0.5rem",
                      color: "grey",
                      "&:hover": {
                        backgroundColor: "neutral.blueShadeBg",
                        color: "gray",
                        "& .MuiSvgIcon-root": {
                          backgroundColor: "neutral.teal",
                          color: "white",
                        },
                      },
                      borderRadius: "14px",
                      textTransform: "capitalize",
                      width: "100%",
                      justifyContent: "flex-start",
                      fontSize: "16px",
                    }}
                    onClick={handleLogout}
                  >
                    Logout
                  </Button>
                </Box>
              </Menu>
            </Box>
          </Box>
        )}

        {!isMdUp && (
          <Box>
            <IconButton onClick={handleMenuOpen} color="black">
              <AccountCircleIcon
                sx={{ height: "3rem", width: "3.5rem", color: "black" }}
              />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              sx={{
                // marginLeft: "2.5rem",
                marginTop: "-0.5rem",
                "& .MuiPaper-root": {
                  borderRadius: "20px",
                  paddingTop: "-16px",
                  minWidth: "260px",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "3px",
                  width: "320px",
                  padding: "10px",
                  borderRadius: "20px",
                  // p: 2,
                }}
              >
                {orgName && (
                  <Box
                    sx={{
                      fontFamily: "Lato",
                      fontWeight: 700,
                      fontSize: "0.95rem",
                      marginLeft: "10px",
                      marginBottom: "2px",
                      color: "neutral.navyBlue",
                    }}
                  >
                    {orgName}
                  </Box>
                )}
                {authState?.first_name && (
                  <Box
                    sx={{
                      fontFamily: "Lato",
                      marginLeft: "10px",
                      marginBottom: "2px",
                    }}
                  >
                    {" "}
                    {authState?.first_name} {authState?.last_name}{" "}
                  </Box>
                )}
                {authState?.email && (
                  <Box
                    sx={{
                      marginBottom: "4px",
                      fontFamily: "Lato",
                      fontSize: "0.87rem",
                      marginLeft: "10px",
                    }}
                  >
                    {authState?.email}
                  </Box>
                )}

                <Box ml={"4px"} mt={"4px"}>
                  <Grid
                    container
                    sx={{
                      gap: "6px", // ⭐ spacing here
                    }}
                  >
                    <Grid
                      item
                      xs={5.8}
                      sx={{
                        backgroundColor: "neutral.blueShadeBg",
                        paddingY: "8px",
                        borderRadius: "14px",
                      }}
                    >
                      <Typography
                        variant="small_Text"
                        sx={{ paddingLeft: "12px", color: "neutral.black" }}
                      >
                        Total
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          paddingRight: "10px",
                        }}
                      >
                        <Box>
                          <Typography
                            variant="heading2_14"
                            sx={{ paddingLeft: "12px" }}
                          >
                            {appointmentStats?.appointments_total || 0}
                          </Typography>
                        </Box>
                        {/* <Box sx={{backgroundColor :'#E5FBF9' , marginRight:"8px",  paddingX:'5px', borderRadius:"20px", color:"#16D7CB" , fontSize:"12px",  fontFamily:"Outfit"}} display={'flex'} alignItems={'center'} >
                                 <ArrowDropUpIcon sx={{color:"#16D7CB"  , padding:'0px'}}/>
       
                                  {(appointmentStats?.appointments_total * 100) /appointmentStats?.appointments_total || 0}%
       
                                 </Box> */}
                      </Box>
                    </Grid>

                    <Grid
                      item
                      xs={5.8}
                      sx={{
                        backgroundColor: "neutral.blueShadeBg",
                        paddingY: "8px",
                        borderRadius: "14px",
                      }}
                    >
                      <Typography
                        variant="small_Text"
                        sx={{ paddingLeft: "12px", color: "neutral.black" }}
                      >
                        Complimentary
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          paddingRight: "10px",
                        }}
                      >
                        <Box>
                          <Typography
                            variant="heading2_14"
                            sx={{ paddingLeft: "12px" }}
                          >
                            {appointmentStats?.appointments_complimentary || 0}{" "}
                            /{" "}
                            {appointmentStats?.appointments_complimentary_total ||
                              0}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#E5FBF9",
                            marginRight: "8px",
                            paddingX: "5px",
                            borderRadius: "20px",
                            color: "#16D7CB",
                            fontSize: "12px",
                            fontFamily: "Outfit",
                          }}
                          display={"flex"}
                          alignItems={"center"}
                        >
                          <ArrowDropUpIcon
                            sx={{ color: "#16D7CB", padding: "0px" }}
                          />
                          {(
                            (appointmentStats?.appointments_complimentary_total *
                              100) /
                              appointmentStats?.appointments_total || 0
                          ).toFixed(2)}
                          %
                        </Box>
                      </Box>
                    </Grid>

                    <Grid
                      item
                      xs={5.8}
                      sx={{
                        backgroundColor: "neutral.blueShadeBg",
                        paddingY: "8px",
                        borderRadius: "14px",
                      }}
                    >
                      <Typography
                        variant="small_Text"
                        sx={{ paddingLeft: "12px", color: "neutral.black" }}
                      >
                        New
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          paddingRight: "10px",
                        }}
                      >
                        <Box>
                          <Typography
                            variant="heading2_14"
                            sx={{ paddingLeft: "12px" }}
                          >
                            {appointmentStats?.appointments_new || 0} /{" "}
                            {appointmentStats?.appointments_new_total || 0}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#E5FBF9",
                            marginRight: "8px",
                            paddingX: "5px",
                            borderRadius: "20px",
                            color: "#16D7CB",
                            fontSize: "12px",
                            fontFamily: "Outfit",
                          }}
                          display={"flex"}
                          alignItems={"center"}
                        >
                          <ArrowDropUpIcon
                            sx={{ color: "#16D7CB", padding: "0px" }}
                          />
                          {(
                            (appointmentStats?.appointments_new_total * 100) /
                              appointmentStats?.appointments_total || 0
                          ).toFixed(2)}
                          %
                        </Box>
                      </Box>
                    </Grid>

                    <Grid
                      xs={5.8}
                      item
                      sx={{
                        backgroundColor: "neutral.blueShadeBg",
                        paddingY: "8px",
                        borderRadius: "14px",
                      }}
                    >
                      <Typography
                        variant="small_Text"
                        sx={{ paddingLeft: "8px", color: "neutral.black" }}
                      >
                        Review
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          paddingRight: "10px",
                        }}
                      >
                        <Box>
                          <Typography
                            variant="heading2_14"
                            sx={{ paddingLeft: "8px" }}
                          >
                            {appointmentStats?.appointments_review || 0} /{" "}
                            {appointmentStats?.appointments_review_total ||
                              0}{" "}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            backgroundColor: "#E5FBF9",
                            marginRight: "8px",
                            paddingX: "5px",
                            borderRadius: "20px",
                            color: "#16D7CB",
                            fontSize: "12px",
                            fontFamily: "Outfit",
                          }}
                          display={"flex"}
                          alignItems={"center"}
                        >
                          <ArrowDropUpIcon
                            sx={{ color: "#16D7CB", padding: "0px" }}
                          />
                          {(
                            (appointmentStats?.appointments_review_total *
                              100) /
                              appointmentStats?.appointments_total || 0
                          ).toFixed(2)}
                          %
                        </Box>
                      </Box>
                    </Grid>

                    <Grid
                      item
                      xs={5.8}
                      sx={{
                        backgroundColor: "neutral.blueShadeBg",
                        paddingY: "8px",
                        borderRadius: "14px",
                      }}
                    >
                      <Typography
                        variant="small_Text"
                        sx={{ paddingLeft: "8px", color: "neutral.black" }}
                      >
                        Old
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          paddingRight: "10px",
                        }}
                      >
                        <Box>
                          <Typography
                            variant="heading2_14"
                            sx={{ paddingLeft: "8px" }}
                          >
                            {appointmentStats?.appointments_old || 0} /{" "}
                            {appointmentStats?.appointments_old_total || 0}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            backgroundColor: "#E5FBF9",
                            marginRight: "8px",
                            paddingX: "5px",
                            borderRadius: "20px",
                            color: "#16D7CB",
                            fontSize: "12px",
                            fontFamily: "Outfit",
                          }}
                          display={"flex"}
                          alignItems={"center"}
                        >
                          <ArrowDropUpIcon
                            sx={{ color: "#16D7CB", padding: "0px" }}
                          />
                          {(
                            (appointmentStats?.appointments_old_total * 100) /
                              appointmentStats?.appointments_total || 0
                          ).toFixed(2)}
                          %
                        </Box>
                      </Box>
                    </Grid>

                    <Grid
                      item
                      xs={5.8}
                      sx={{
                        backgroundColor: "neutral.blueShadeBg",
                        paddingY: "8px",
                        borderRadius: "14px",
                      }}
                    >
                      <Typography
                        variant="small_Text"
                        sx={{ paddingLeft: "8px", color: "neutral.black" }}
                      >
                        Cancelled
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          paddingRight: "10px",
                        }}
                      >
                        <Box>
                          <Typography
                            variant="heading2_14"
                            sx={{ paddingLeft: "8px" }}
                          >
                            {appointmentStats?.appointments_cancelled || 0}{" "}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#FFE5F6",
                            marginRight: "8px",
                            paddingX: "5px",
                            borderRadius: "20px",
                            color: "#FF392B",
                            fontSize: "12px",
                            fontFamily: "Outfit",
                          }}
                          display={"flex"}
                          alignItems={"center"}
                        >
                          <ArrowDropUpIcon
                            sx={{
                              color: "#FF392B",
                              padding: "0px",
                              transform: "rotate(180deg)",
                            }}
                          />
                          {(
                            (appointmentStats?.appointments_cancelled * 100) /
                              appointmentStats?.appointments_total || 0
                          ).toFixed(2)}
                          %
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                <Button
                  //  style={{border :'2px solid black'}}
                  disableRipple
                  startIcon={
                    <LogoutOutlinedIcon
                      sx={{
                        borderRadius: "50%",
                        padding: "8px",
                        color: "neutral.navyBlue",
                        "&:hover": {
                          // backgroundColor: "neutral.navyBlue",
                          color: "white",
                        },
                      }}
                    />
                  }
                  sx={{
                    backgroundColor: "neutral.blueShadeBg",
                    marginTop: "0.5rem",
                    color: "grey",
                    "&:hover": {
                      backgroundColor: "neutral.blueShadeBg",
                      color: "gray",
                      "& .MuiSvgIcon-root": {
                        backgroundColor: "neutral.teal",
                        color: "white",
                      },
                    },
                    borderRadius: "14px",
                    textTransform: "capitalize",
                    width: "100%",
                    justifyContent: "flex-start",
                    fontSize: "16px",
                  }}
                  onClick={handleLogout}
                >
                  Logout
                </Button>
              </Box>
            </Menu>
          </Box>
        )}
      </Toolbar>
      {/* {Modals} */}
      <CustomModal
        customStyles={{ minWidth: "70%" }}
        open={open}
        onClose={handleAppointmentStatusClose}
      >
        <FutureAppointmentStatus onClose={handleAppointmentStatusClose} />
      </CustomModal>

      <CustomModal
        customStyles={{ minWidth: "70%" }}
        open={dashBoardOpen}
        onClose={() => setDashBoardOpen(false)}
      >
        <DoctorDashboard onClose={() => setDashBoardOpen(false)} />
      </CustomModal>
    </>
  );
};

export default PrescriptionNavbar;
